module.exports = {"210202001":"海军广场街道","210202005":"人民路街道","210202008":"青泥洼桥街道","210202010":"葵英街道","210202011":"桃源街道","210202012":"老虎滩街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210202.json
// module id = 602
// module chunks = 0